
import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class DataBatch {
	static init() {
		this.items = document.querySelectorAll("[data-batch]");

		ScrollTrigger.batch(this.items, {
			onEnter: batch => gsap.to(batch, {
				y: 0,
				autoAlpha: 1,
				stagger: 0.1
			})
		});
	}
}
